// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h2[data-v-2a66459f],h3[data-v-2a66459f],h4[data-v-2a66459f]{margin-top:1rem}.markdown a[data-v-2a66459f]{text-decoration-line:underline}li[data-v-2a66459f]{list-style-position:inside;list-style-type:disc}p[data-v-2a66459f]{font-weight:300;margin-bottom:1rem;margin-top:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
